import { createRoot } from 'react-dom/client';
import BilberryCustomElement from 'src/widgets/BilberryCustomElement';
import { WidgetWrapper } from 'src/widgets/WidgetWrapper';
import SmartEventDetails from './SmartEventDetails';

class BilberrySmartEventDetails extends BilberryCustomElement {
    protected renderWidget(): void {
        const id = Number(this.getAttribute('smart-event-id'));

        createRoot(this._mountPoint).render(
            <WidgetWrapper
                mountPoint={this._mountPoint}
                popoverMountPoint={this._popoverMountPoint}
                shadowRoot={this._shadowRoot}
            >
                <SmartEventDetails id={id} />
            </WidgetWrapper>,
        );
    }
}

export default function defineCustomElement(): void {
    customElements.define('bilberry-smart-event-details', BilberrySmartEventDetails);
}
